import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';


export const genericAccordionStyles = makeStyles((theme) => ({
    accordionContainer: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        borderRadius: '3px',
        background: tcsmColors.greyFive,
        '& .MuiAccordion-root': {
            boxShadow: 'none',

            '&:before': {
                display: 'none',
            },
            '& + .MuiAccordion-root': {
                borderTop: `1px solid ${tcsmColors.greyFive}`,
            },
        },
        '& .MuiAccordionSummary-root': {
            padding: '1rem 1rem 0 1rem',
            position: 'relative',
            '& > div': {
                margin: 0,
                display: 'block',
            },
            '& .MuiAccordionSummary-expandIcon': {
                position: 'absolute', // Position trigger button due to limited html editing capabilities of MUI accordion
                right: 0,
                margin: 0,
                top: 0,

                '& svg': {
                    fill: tcsmColors.blue,
                },
            },


        },
        '& .MuiAccordionDetails-root': {
            padding: '0rem 1rem 1rem 1rem',
            display: 'block',
        },
        '& .generic-accordion': {
           
            
            '&-item': {
               

                '&-subheader': {
                    marginBottom: theme.spacing(.5),

                    [theme.breakpoints.down('sm')]: {
                        marginBottom: theme.spacing(.25),
                    },
                    '&-expanded': {
                        marginTop: theme.spacing(.5),
    
                        [theme.breakpoints.down('sm')]: {
                            marginTop: theme.spacing(.25),
                        },
                    },
                },                
            },
        },
    },

}));



